var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6996 23.4711C30.6996 23.4711 23.2328 35.5783 17.1109 35.5783C6.4031 35.5783 16.382 12.5134 24.1916 12.5134C29.641 12.5134 30.6996 23.4711 30.6996 23.4711Z",
    fill: "#FF6600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5723 38.6973C37.4451 40.9608 34.8198 42.6977 31.9044 43.7702C28.989 44.8427 25.8639 45.2214 22.7767 44.8762C19.6895 44.531 16.7252 43.4714 14.1188 41.7814C11.5125 40.0915 9.33573 37.8176 7.76123 35.1402C9.5314 37.5478 12.5338 39.1528 16.803 39.1528C27.3199 39.1528 33.2899 30.9801 33.2899 30.9801C33.2899 30.9801 33.8062 37.4393 39.5593 38.6973H39.5723Z",
    fill: "#FF6600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7223 15.7452C44.2963 18.7528 45.0781 22.1117 44.9939 25.5051C44.9096 28.8985 43.9621 32.2145 42.2407 35.1402C40.8792 34.3766 39.8725 33.1083 39.4379 31.6091L37.1558 24.7725L42.7223 15.7452Z",
    fill: "#FF6600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0031 5.01737C30.0185 5.01403 34.8513 6.89881 38.5398 10.2967L34.7521 16.4088C33.3811 12.843 30.5957 9.2729 25.1767 9.2729C14.0784 9.2729 5.85231 21.3888 5.85231 28.9846C5.84986 29.9669 5.97528 30.9454 6.22543 31.8953C5.11558 28.8725 4.75205 25.6265 5.16572 22.4331C5.57938 19.2398 6.75802 16.1934 8.60147 13.5531C10.4449 10.9127 12.8987 8.75634 15.7542 7.26726C18.6097 5.77818 21.7826 5.00039 25.0031 5V5.01737Z",
    fill: "#FF6600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcLogo);
export default __webpack_public_path__ + "static/media/acLogo.47915af06818f4c704d399fc8b2142be.svg";
export { ForwardRef as ReactComponent };